'use strict';

module.exports = {
    'lang': 'zh-cn',
    'title': '默认筛选',
    'resetName': '清空',
    'searchName': '查询',
    'down': '展开',
    'up': '收起',
    'en-us': {
        'title': 'Default Filter',
        'resetName': 'Clear',
        'searchName': 'Query',
        'down': 'Expand',
        'up': 'Collapse'
    },
    'zh-tw': {
        'title': '默認篩選',
        'resetName': '清空',
        'searchName': '查詢',
        'down': '展開',
        'up': '收起'
    }
};